import styles from './not-found.module.css';

export const NotFoundPage = () => {
  return (
    <div className={styles.container}>
      <img className={styles.logo} src="logo.svg" alt="playwall logo" />

      <span className={styles.text}>Page Not Found</span>
      <div />
    </div>
  );
};
